export default __webpack_public_path__ + "static/media/evreux3.8205001a.jpg";